export var TalentStatusList;
(function (TalentStatusList) {
    TalentStatusList["NOTYET"] = "NotYet";
    TalentStatusList["ONGOING"] = "OnGoing";
    TalentStatusList["DONE"] = "Done";
    TalentStatusList["CANCELLED"] = "Cancelled";
    TalentStatusList["REJECTED"] = "Rejected";
})(TalentStatusList || (TalentStatusList = {}));
